import runSsrSafely from '@utils/ssr/runSsrSafely';
import fetchTemplateDesigner from '@utils/ssr/fetchTemplateDesigner';

export default function ssrFetch(ctx) {
    const options = ctx.timeout ? {timeout: ctx.timeout} : {};
    return runSsrSafely(fetchTemplateDesigner({...ctx, options}));
}
